import { defineStore } from 'pinia';
import { fetchLlmTemplate, createLlmTemplate, deleteLlmTemplate } from "@/services/ppApi";
import { useAccountStore } from '@/stores/account';

export const useLlmTemplatesStore = defineStore('llmTemplates', {
    state: () => {
        return {
            templates: [],
            loading: false,
            error: null,
            found: 0
        }
    },
    actions: {
        resetLlmTemplates() {
            this.$reset();
        },
        async getLlmTemplates(forceFetch = false) {
            if(forceFetch || (this.templates && this.templates.length < 1)) {
                await this.fetchLlmTemplates();
            }
            return this.templates.length > 0;
        },
        async fetchLlmTemplates() {
            if(this.loading) return;

            this.loading = true;
            this.error = null;

            try {
                const params = {
                    account_id: useAccountStore().account.account_id,
                    type: 'custom,example'
                };

                const response = await fetchLlmTemplate(params);

                if(response?.data?.llm_template?.length > 0) {
                    this.templates = response.data.llm_template;
                    this.found = response.data.found;
                } else {
                    this.templates = [];
                    this.found = 0;
                }
            } catch (error) {
                this.templates = [];
                this.found = 0;
                this.error = error;
            } finally {
                this.loading = false;
            }
        },
        async deleteLlmTemplate(id) {
            let llmTemplate = {
                template: id,
                status: 0,
                account_id: useAccountStore().account.account_id
            }

            try {
                await deleteLlmTemplate(llmTemplate);
                this.templates = this.templates.filter(template => template.template !== id);
                return true;
            } catch (error) {
                return false;
            }
        },
        async cloneLlmTemplate(template) {
            let llmTemplate = {
                ...template,
                account_id: useAccountStore().account.account_id
            }

            delete llmTemplate.editable;
            delete llmTemplate.status;
            delete llmTemplate.type;
            delete llmTemplate.created_by;

            try {
                const response = await createLlmTemplate(llmTemplate);

                if(response?.data?.llm_template[0]?.template) {
                    this.fetchLlmTemplates();
                    return true;
                } else {
                    return false;
                }
            } catch (error) {
                return error;
            }
        },
    }
});
